import { watch } from "vue";
import { useNgSession } from "../ng/ng-session";
import { ContactWecomaKeys, type PlayerContact } from "./models/contact";
import { httpClient } from "@sazka/utils/http-clients/http-client";
import { useSessionStorage } from "@sazka/utils/use-storage";

export const WECOMA_KEY_STORAGE = "wecoma-keys";

export async function logLogin(contact?: PlayerContact) {
    const { isLoggedIn, session } = useNgSession();
    if (!isLoggedIn.value) return;

    const response = await httpClient.post<ContactWecomaKeys>("/api/player/login", {
        playerId: session.value.PlayerID,
        contact: contact ?? {
            birthday: session.value.Birthday,
            city: session.value.City,
            firstName: session.value.PlayerName,
            lastName: session.value.PlayerLastName,
            email: session.value.PlayerEmail,
            phoneNumber: session.value.PlayerCellphone,
            vipLevel: session.value.PlayerVipLevel,
            registrationDate: session.value.PlayerRegistrationDate,
            countryCode: session.value.CountryCode,
        },
    });

    const storage = useSessionStorage();
    storage.setJson<ContactWecomaKeys>(WECOMA_KEY_STORAGE, response.data, "essential");

    watch(isLoggedIn, async (loggedIn) => {
        if (!loggedIn) {
            storage.removeItem(WECOMA_KEY_STORAGE);
        }
    });
}
